<div class="cmg-split-button-container" (mouseenter)="activateMenu()">
  <button class="cmg-split-button">
    <ng-content select="[button-content]" />
  </button>
  <button type="button" class="cmg-split-button-menu-button" #activateButton>
    <span class="pi pi-chevron-down"></span>
  </button>
</div>
<div class="dropdown-panel" #panel [ngClass]="{ open: isShowingMenu }">
  <div class="dropdown-panel-content" (click)="closeMenu()">
    @for (menuOption of menuItems(); track menuOption; let i = $index) {
      <ng-template #defaultTemplate let-menuOption>{{ menuOption }}</ng-template>
      <ng-container [ngTemplateOutlet]="optionTemplate() || defaultTemplate" [ngTemplateOutletContext]="{ $implicit: menuOption, index: i }" />
    }
  </div>
</div>
